import clsx from "classnames"
import React from "react"
import { usePageProps } from "common/hooks/data/usePageProps"
import type { AppProps } from "common/lib/getAppServerSideProps"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { pageUrl } from "common/lib/router"
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig"

export const NavItems = () => {
  const { navItems, pageSlug, regionCode } = usePageProps<AppProps>()
  const t = useTranslations("layout.header")
  const currentPathname = pageUrl.view({ regionCode, pageSlug })
  const regionConfig = useRegionConfig()
  const {
    section_nav: { custom_nav_link: customNavLink },
  } = regionConfig

  const navItemsWithHome = [{ path: `/${regionCode}/home-page`, title: t("home") }, ...navItems]

  return (
    <div
      className="font-sans-heading my-3 mb-8 flex flex-col text-xl font-bold"
      role="menu"
      aria-orientation="vertical"
    >
      {navItemsWithHome.map(({ path, title }) => (
        <a
          key={path}
          href={path}
          className={clsx("my-1.5 border-l-8 py-0.5 pl-2 -outline-offset-1 hover:underline", {
            "border-gray-700": currentPathname === path,
            "border-white": currentPathname !== path,
          })}
          role="menuitem"
        >
          {title}
        </a>
      ))}
      {customNavLink.enabled && (
        <a
          href={customNavLink.link}
          className={clsx("my-1.5 border-l-8 py-0.5 pl-2 -outline-offset-1 hover:underline", {
            "border-gray-700": currentPathname === customNavLink.link,
            "border-white": currentPathname !== customNavLink.link,
          })}
          role="menuitem"
        >
          {customNavLink.title}
        </a>
      )}
    </div>
  )
}
